// extracted by mini-css-extract-plugin
export var actionButton = "_m2-t";
export var buttonContainer = "_m2-0";
export var buttonContainer2 = "_m2-1";
export var buttonSection = "_m2-2";
export var details = "_m2-3";
export var dropdownItem = "_m2-5";
export var dropdownItemsContainer = "_m2-4";
export var fileInput = "_m2-r";
export var headerButton = "_m2-6";
export var icon = "_m2-7";
export var input = "_m2-8";
export var macroListItem = "_m2-9";
export var mainContent = "_m2-a";
export var microText = "_m2-b";
export var modal = "_m2-w";
export var optionsButton = "_m2-c";
export var paperclip = "_m2-s";
export var pillContent = "_m2-d";
export var preview = "_m2-e";
export var preview2 = "_m2-f";
export var quillEditor = "_m2-q";
export var selectedMacro = "_m2-g";
export var sidebar = "_m2-h";
export var sidebarHeader = "_m2-j";
export var sidebarList = "_m2-i";
export var sidebarListItem = "_m2-k";
export var sidebarSearch = "_m2-l";
export var snoozeDurationWrapper = "_m2-v";
export var statusPillContainer = "_m2-m";
export var tagsContainer = "_m2-n";
export var unselectedMacro = "_m2-o";
export var variable = "_m2-u";
export var wrapper = "_m2-p";